<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">

    <message-test-number-input
      @hide="hideTestInputPrompt"
      @send-test-message="_sendTestMessage($event)"
      :is-visible="isTestInputPromptVisible"

    />

    <v-card>

      <v-card-title>
        <span class="headline">

          <span v-if="!patients && !patients.length"> Compose Message </span>
          <span v-if="patients && patients.length > 0"> Compose Mass Message </span>

        </span>
      </v-card-title>

      <v-card-text>
        <v-container>

          <v-row>
            <v-col cols="12">
              <v-text-field v-model="field.name" label="Name" />
            </v-col>
          </v-row>
          <v-row>

            <div class="placeHoldersWrapper">

              <div class="templateTypeSelectorOuterWrapper">
                <div class="templateTypeSelectorInnerWrapper">

                  <div
                    :class="selectedTemplateType === 'userTemplates' ? 'tab selected' : 'tab'"
                    @click="_selectTemplateType('userTemplates')"
                  >
                    Practice Templates
                  </div>

                  <div
                    :class="selectedTemplateType === 'systemTemplates' ? 'tab selected' : 'tab'"
                    @click="_selectTemplateType('systemTemplates')"
                  >
                    System Templates
                  </div>

                </div>
              </div>

              <div class="label">Select a template to use:</div>
              <v-select
                v-model="selectedTemplateId"
                class="filterSelector"
                :items="selectableTemplates"
                label="Select Template"
                item-text="name"
                item-value="templateID"
              />

            </div>

          </v-row>

          <v-textarea
            v-model="field.message"
            label="Message *"
            required
            :disabled="isContentDisabled"
            full-width
            single-line
          />

          <div class="messageCharCounter">

            <span :class="field.message.length > maxAllowedChars ? 'messageCharCounterexcedded' : ''" >{{ field.message.length }}</span>{{ " /" }} {{ maxAllowedChars }}

          </div>

          <v-row>
            <v-col cols="12">
              <v-text-field v-model="field.signature" label="Signature" />
            </v-col>
          </v-row>

          <v-row v-if="!isContentDisabled">

            <v-col cols="12">

              <input ref="file" type="file" style="display: none" @change="onFileChange" />

              <div
                v-if="!!file || (selectedTemplateMediaUrl && selectedTemplateMediaUrl.length)"
                class="fileWrapper"
              >
                <div class="filePart">

                  <div class="iconWrapper">
                    <v-icon>mdi-file</v-icon>
                  </div>

                  <div class="nameWrapper">
                    {{
                      file && file.name
                        ? file.name
                        : selectedTemplateMediaUrl.split("/")[
                            selectedTemplateMediaUrl.split("/").length - 1
                          ]
                    }}
                    <div class="fileSize">Size: {{ file ? formatMemory(file.size) : "" }}</div>
                  </div>
                </div>

                <div class="actionPart" @click="$refs.file.click()">

                  <div class="changeBtn">
                    <v-icon>mdi-refresh</v-icon>
                    Change
                  </div>

                  <div class="removeBtn" @click="onFileDelete">
                    <v-icon>mdi-delete</v-icon>
                  </div>

                </div>
              </div>

              <div
                v-if="!(!!file || (selectedTemplateMediaUrl && selectedTemplateMediaUrl.length))"
                class="uploadBtn"
                @click="$refs.file.click()"
              >

                <div class="iconWrapper">
                  <v-icon>mdi-attachment</v-icon>
                </div>

                <div class="labelWrapper">Attach an image</div>

              </div>

            </v-col>
          </v-row>

        </v-container>
      </v-card-text>

      <v-card-actions>

        <v-spacer />

        <v-btn color="secondary" text @click="close"> Cancel </v-btn>
        <v-btn v-if="!shouldSchedule" color="primary" text @click="send"> Send </v-btn>
        <v-btn v-if="shouldSchedule" color="primary" text @click="schedule"> Schedule </v-btn>

      </v-card-actions>

    </v-card>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import moment from "moment";
  import { Datetime } from "vue-datetime";
  // You need a specific loader for CSS files
  import "vue-datetime/dist/vue-datetime.css";
  import "vue2-timepicker/dist/VueTimepicker.css";
  // Main JS (in UMD format)
  import VueTimepicker from "vue2-timepicker";
  import { ApiCalls } from "../../../../api-calls";
  import UserHelper from "../../../../utils/user-helper";
  import Api from "../../../shared-module/api";
  import HelperMethods from "../../../../utils/helper-methods";

  export default {
    name: "MessageComposerDialog",
    components: {
      MessageTestNumberInput: () =>
        import("../message-test-number-input/message-test-number-input.vue"),
      datetime: Datetime,
      VueTimepicker: VueTimepicker,
    },
    props: {
      patients: {
        type: Array,
        default: null,
      },
      isVisible: {
        type: Boolean,
        default: false,
      },
      sanitize: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      dialog: false,
      field: {
        name: "",
        message: "",
        mediaUrl: "",
        testNumber: "",
        signature: "",
      },
      twilioSid: "ACfffb0bc0e31d44d40c9ecf9e6647c69d",
      practiceID: "",
      maxMessageLength: 200,
      snackbar: false,
      startDate: "",
      endDate: "",
      time: "",
      notification: "Unknown",
      selectedTemplateMediaUrl: "",
      file: null,
      validNumbers: [],
      isTestInputPromptVisible: false,
      messageTemplates: [],
      shouldSchedule: false,
      selectedTemplateId: null,
      selectedTemplate: null,
      isContentDisabled: false,
      templates: [],
      selectedPatients: [],
      selectedTemplateType: "userTemplates",
      selectableTemplates: [],
      maxAllowedChars: 140,
      selectedFrequency: 0,
      allFrequencies: [
        {
          label: "Select One",
          value: 0,
        },
        {
          label: "Daily",
          value: "2",
        },
        {
          label: "Weekly",
          value: "3",
        },
        {
          label: "Monthly",
          value: "4",
        },
        {
          label: "Yearly",
          value: "5",
        },
      ],
    }),

    watch: {
      templates(val) {
        if (val && val.length) {
          this.messageTemplates = val.filter((t) => t.templateTypeID === 1);
        }
      },
      "$store.state.posActivePractice": function () {
        this._loadMetadata();
      },
      selectedTemplateId(val) {
        this.isContentDisabled = false;
        this.selectedTemplate = null;
        this.field.message = "";
        this.selectedTemplateMediaUrl = "";
        if (val > 0) {
          const template = this.selectableTemplates.find((t) => t.templateID === val);
          if (template) {
            this.selectedTemplate = template;
            this.field.message = template.templateBody ? template.templateBody : "";
            this.field.message = template.templateBody ? template.templateBody : "";
            if (template.flowID && template.flowID.length) {
              this.isContentDisabled = true;
            }
            if (template.mediaURL && template.mediaURL.length) {
              this.selectedTemplateMediaUrl = template.mediaURL;
            }
          }
        }
      },
      selectedTemplateType(val) {
        this._onTemplateTypeUpdate(val);
      },
      patients(val) {
        if (val && val.length) {
          this.selectedPatients = val;
          if (this.sanitize) {
            this._sanitizePatients();
          }
        }
      },
    },

    created() {
      this._loadMetadata();
    },

    methods: {

      mounted() {
        console.log('Patients: ' + this.selectedPatients);
      },

      async _sanitizePatients() {
        let numbersToSanitize = "";
        var numberMappedObject = [];

        if (this.selectedPatients && this.selectedPatients.length) {

          const formattedPatients = this.patients.map((p) => {

            if (p.phone && p.phone.length) {
              numbersToSanitize += `${p.phone};`;
            }

          });

          // Call sanitize patients API and store only valid patients
          const sanitizedPatients = [];
          this.validNumbers = [];

          try {
            const { data: numbers = [] } = await ApiCalls.sanitizePhoneNumbers({
              PhoneNumbers: numbersToSanitize,
            });

            numbers.forEach((n) => {
              numberMappedObject[n.cellNumber] = n.numberType.type;
            });

            formattedPatients.forEach((p, pIndex) => {

              if (numberMappedObject[p.phone] && numberMappedObject[p.phone].length) {

                this.validNumbers.push(p.phone);

                }
              
            });

          } catch (error) {
            console.log("error :>> ", error);
          }
        }
      },
      _getPracticeIdFromStore() {
        let practiceId = null;
        if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
          practiceId = this.$store.state.posActivePractice.value;
        }
        return practiceId;
      },
      async _loadMetadata() {
        try {
          await Promise.allSettled([this._fetchPracticeTemplates(), this._fetchSystemTemplates()]);
          this.selectedTemplateType = "userTemplates";
          this._onTemplateTypeUpdate("userTemplates");
        } catch (error) {
          console.log("error :>> ", error);
          // setTimeout(() => {
          //   this.isPromptVisible = false;
          // }, 1000);
        }
      },
      async _fetchPracticeTemplates() {
        let practiceTemplates = [];
        try {
          const storePracticeId = this._getPracticeIdFromStore();
          const { data } = await Api.template.private.fetchPracticeTemplates({
            templateCategoryId: 3,
            practiceId: storePracticeId,
          });
          practiceTemplates = data;
        } catch (error) {
          console.log("error", error);
        }
        this.userTemplates = this._filterTemplates(practiceTemplates);
      },
      async _fetchSystemTemplates() {
        let systemTemplates = [];
        try {
          const { data } = await Api.template.private.fetchSystemTemplates({
            templateCategoryId: 3,
            templateTypeId: 1,
          });
          systemTemplates = data;
        } catch (error) {
          console.log("error", error);
        }
        this.systemTemplates = this._filterTemplates(systemTemplates);
      },
      _filterTemplates(allTemplates) {
        let filteredTemplates = allTemplates.filter((template) => template.templateTypeID === 1);
        filteredTemplates = filteredTemplates.filter(
          (template) => template.templateCategoryID !== 2 && template.templateCategoryID !== 1
        );
        return filteredTemplates;
      },
      _selectTemplateType(templateType) {
        this.selectedTemplateType = templateType;
      },
      _onTemplateTypeUpdate(val) {
        this.selectedTemplateId = null;
        this.selectedTemplate = null;
        this.isContentDisabled = false;
        this.selectedTemplate = null;
        this.selectedTemplateMediaUrl = "";
        this.field.message = "";
        this.field.signature = "";
        if (val === "userTemplates") {
          this.selectableTemplates = this.userTemplates;
        } else {
          // System templates
          this.selectableTemplates = this.systemTemplates;
        }
      },
      replaceBody(template) {
        if (template.mediaURL && template.mediaURL.length) {
          this.selectedTemplateMediaUrl = template.mediaURL;
        } else {
          this.selectedTemplateMediaUrl = "";
        }
        this.field.message = template.templateBody;
      },

      _prependAreaCodeIfRequired(phoneNumber) {
        if (phoneNumber && phoneNumber.length) {
          if (phoneNumber.indexOf("+1") === 0) {
            return phoneNumber;
          } else {
            return `+1${phoneNumber}`;
          }
        }
        return null;
      },

       send() {
        if (!Array.isArray(this.selectedPatients) && !this.selectedPatients.length) {
          return;
        }

         const activeClinic = UserHelper.getActiveClinic();
         const activePracticeId = activeClinic.PracticeID;

         this.$emit("on-send-start");
         let mediaUrl = "";

         if (this.file) {

           mediaUrl = this.uploadFile();

         } else if (this.selectedTemplateMediaUrl && this.selectedTemplateMediaUrl.length) {

           mediaUrl = this.selectedTemplateMediaUrl;

         }

        if (!this.field.message.length && !this.file) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please add a message";
          this.snackbar = true;
          return;
        }

        if (!HelperMethods.validateMessagePlaceholders(this.field.message)) {
          this.snackbar = true;
          this.notification = "First name and Last name in the same message violates HIPAA laws";
          return;
        }

         if (this.selectedPatients && this.selectedPatients.length) {

          // Send to selected patients only
          let phoneNumbers = [];
          this.selectedPatients.forEach((patient) => {

            console.log(patient);

            const phoneNumber = this._prependAreaCodeIfRequired(patient.phone);
            if (phoneNumber) {
              phoneNumbers.push(phoneNumber);
            }

            else {
              const messagePayload = {
                CellNumber: this.selectedPatients[0].phone,
                Message: this.selectedTemplate ? this.selectedTemplate.templateBody : '',
                CampaignName: this.selectedTemplate ? this.selectedTemplate.name : '',
                PracticeID: this.$store.state.posActivePractice.value,
                GroupID: this.selectedGroupId,
                MessageCategoryTypeID: 3,
                MediaURL: mediaUrl,
                TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
                TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : '',
                StartDate: new Date().toLocaleString()
              };

              try {

                ApiCalls.scheduleMessage(messagePayload);
                // Success
                this.$emit("on-success");
                this.close();

              } catch (error) {

                this.$emit("on-error", error);

              }
            }
            
          });

          if (this._isFlowExecutionRequired()) {

            // Template has a flowid
            this._executeFlow(phoneNumbers.join(";"));

          } else {

            // Template does not have a flowid
            let campaignName = this.field.name;

            if (!(campaignName && campaignName.length)) {
              campaignName = `${activePracticeId}-${+new Date()}`;
            }

            if (this.sanitize) {
              phoneNumbers = this.validNumbers;
            }

            const messagePayload = {
              CellNumber: this.selectedPatients[0].phone,
              Message: this.selectedTemplate ? this.selectedTemplate.templateBody : this.field.message.length ? this.field.message : null,
              CampaignName: this.selectedTemplate ? this.selectedTemplate.name : '',
              PracticeID: this.$store.state.posActivePractice.value,
              GroupID: this.selectedGroupId,
              MessageCategoryTypeID: 3,
              MediaURL: mediaUrl,
              TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
              TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : '',
              StartDate: new Date().toLocaleString()
            };

            if (mediaUrl && mediaUrl.length) {
              messagePayload.MediaURL = mediaUrl;
            }

            try {
              ApiCalls.sendMessage(messagePayload);
              // Success
              this.$emit("on-success");
              this.close();
            } catch (error) {
              this.$emit("on-error", error);
            }
          }
        }
      },

      _sendTestMessage(testCellNumber) {
        this.$emit("on-send-start");
        var messagePayload = {};
        // Prepare message payload with the first patient's first and last name
        const activeClinic = UserHelper.getActiveClinic();
        const activePracticeId = activeClinic.PracticeID;
        let campaignName = this.field.name;
        if (!(campaignName && campaignName.length)) {
          campaignName = `${activePracticeId}-${+new Date()}`;
        }
        let mediaUrl = "";
        if (this.file) {
          mediaUrl = this.uploadFile();
        } else if (this.selectedTemplateMediaUrl && this.selectedTemplateMediaUrl.length) {
          mediaUrl = this.selectedTemplateMediaUrl;
        }

        if (this.patients && this.patients.length) {
          // Send to selected patients only
          const phoneNumbers = [];
          this.patients.forEach((patient) => {
            console.log(patient);
            alert('To Number: ' + testCellNumber)
            const phoneNumber = this._prependAreaCodeIfRequired(testCellNumber);
            if (phoneNumber) {
              phoneNumbers.push(patient.cellNumber);

              messagePayload = {
                ToNumbers: phoneNumbers,
                Message: this.field.message,
                CampaignName: campaignName,
                PracticeID: this.$store.state.posActivePractice.value,
                MediaURL: mediaUrl,
                Signiture: this.field.signature,
                MessageCategoryTypeID: 3,
                SendDate: new Date().toLocaleString(),
                TemplateID: this.selectedTemplate ? this.selectedTemplate.templateID : null,
                TemplateName: this.selectedTemplate ? this.selectedTemplate.name : '',
              };
            }

            ApiCalls.sendMessage(messagePayload);
            //try {
            //  await ApiCalls.sendMessage(messagePayload);
            //  // Success
            //  this.$emit("on-test-success");
            //} catch (error) {
            //  this.$emit("on-error", error);
            //}

          });
        }

        if (this._isFlowExecutionRequired(phoneNumbers)) {
          this._executeFlow(phoneNumbers);
        }
        else {
          try {

            // Success
            this.$emit("on-test-success");
          } catch (error) {
            this.$emit("on-error", error);
          }

          this.hideTestInputPrompt();
        }
      },

      showTestInputPrompt() {
        if (!Array.isArray(this.patients) && !this.patients.length) {
          return;
        }
        if (!this.field.message.length && !this.file) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please add a message";
          this.snackbar = true;
          return;
        }
        if (!HelperMethods.validateMessagePlaceholders(this.field.message)) {
          this.snackbar = true;
          this.notification = "First name and Last name in the same message violates HIPAA laws";
          return;
        }
        this.isTestInputPromptVisible = true;
      },

      hideTestInputPrompt() {
        this.isTestInputPromptVisible = false;
      },

      async schedule() {
        // Check if date and time are valid
        if (!(this.startDate && this.startDate.length)) {
          this.notification = "Please provide a valid date";
          this.snackbar = true;
          return;
        }
        if (!(this.time && this.time.length)) {
          this.notification = "Please provide a valid time";
          this.snackbar = true;
          return;
        }
        const datePart = this.startDate.split("T")[0];
        const dateTime = moment(`${datePart} ${this.time}`, "YYYY-MM-DD LT");
        if (!dateTime.isValid()) {
          this.notification = "Please select a valid time";
          this.snackbar = true;
          return;
        }
        let endDateTime = null;
        if (this.endDate) {
          const endDatePart = this.endDate.split("T")[0];
          endDateTime = moment(`${endDatePart} ${this.time}`, "YYYY-MM-DD LT", true);
        }
        // const formattedDateTime = `${moment(datePart, 'YYYY-MM-DD').format('MM/DD/YYYY')} ${moment(this.time, 'h:mm a').format('HH:mm')}`
        if (!this.field.message.length && !this.file) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please add a message";
          this.snackbar = true;
          return;
        }
        if (!HelperMethods.validateMessagePlaceholders(this.field.message)) {
          this.snackbar = true;
          this.notification = "First name and Last name in the same message violates HIPAA laws";
          return;
        }
        if(this.selectedPatients && this.selectedPatients.length) {
          // Send to selected patients only
          const phoneNumbers = [];
          this.selectedPatients.forEach((patient) => {
            console.log(patient);
            //alert('To Number: ' + patient.phone);
            const phoneNumber = this._prependAreaCodeIfRequired(patient.cellNumber);
            if (phoneNumber) {
              phoneNumbers.push(phoneNumber);
            }
          });
          this.$emit("on-send-start");
          const activeClinic = UserHelper.getActiveClinic();
          const activePracticeId = activeClinic.PracticeID;
          let campaignName = this.field.name;
          if (!(campaignName && campaignName.length)) {
            campaignName = `${activePracticeId}-${+new Date()}`;
          }
          let mediaUrl = "";
          if (this.file) {
            mediaUrl = await this.uploadFile();
          } else if (this.selectedTemplateMediaUrl && this.selectedTemplateMediaUrl.length) {
            mediaUrl = this.selectedTemplateMediaUrl;
          }

          const messagePayload = {
            ToNumbers: phoneNumbers,
            Message: this.field.message,
            CampaignName: campaignName,
            PracticeID: this.$store.state.posActivePractice.value,
            MessageTypeID: 1,
            StartDate: dateTime,
            MediaURL: mediaUrl,
            Signiture: this.field.signature,
            MessageCategoryTypeID: 3,
            SendDate: new Date().toLocaleString(),
            TemplateID: this.selectedTemplate ? this.selectedTemplate.templateID : null,
            TemplateName: this.selectedTemplate ? this.selectedTemplate.name : '',
          };
          if (endDateTime) {
            messagePayload.EndDate = endDateTime;
          }
          if (this.selectedFrequency > 0) {
            messagePayload.Recurring = this.selectedFrequency;
          }
          try {
            await ApiCalls.createSchedule(messagePayload);
            // Success
            this.$emit("on-success");
            this.close();
          } catch (error) {
            this.$emit("on-error", error);
          }
        }
      },

      close() {
        this.$emit("dismiss");
        this.file = null;
        this.field = Object.assign({
          name: "",
          message: "",
          mediaUrl: "",
          group: "",
          signature: "",
        });
        this.selectedTemplateMediaUrl = "";
        this.startDate = "";
        this.endDate = "";
        this.time = "";
        this.shouldSchedule = false;
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.isContentDisabled = false;
        this.file = null;
        this.selectedFrequency = 0;
      },

      _getValidHourRanges() {
        let validHourRange = [[8, 20]];
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            // eslint-disable-next-line no-undef
            // eslint-disable-next-line radix
            const currentHour = parseInt(moment().format("H"));
            if (currentHour > 20) {
              validHourRange = [];
            } else {
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              const currentMinute = parseInt(moment().format("m"));
              if (currentMinute < 45) {
                validHourRange = [[currentHour, 20]];
              } else {
                validHourRange = [[currentHour + 1, 20]];
              }
            }
          }
        }
        return validHourRange;
      },

      onFileChange(e) {
        const allowedFileTypes = ["image/jpeg", "image/gif", "image/png"];
        const uploadedFile = e.target.files[0];
        // Check if file type is valid
        if (allowedFileTypes.indexOf(uploadedFile.type) > -1) {
          // Check if it exceeds the size limit
          const allowedFileSize = process.env.VUE_APP_MMS_ATTACHMENT_SIZE_LIMIT_IN_KB || 4 * 1024;
          if (uploadedFile.size / 1024 <= allowedFileSize) {
            // eslint-disable-next-line prefer-destructuring
            this.file = e.target.files[0];
          } else {
            this.notification = `File size too large, maximum allowed size is ${allowedFileSize / 1024
              } MB`;
            this.snackbar = true;
          }
        } else {
          this.notification = "The selected file type is not allowed";
          this.snackbar = true;
        }
      },

      onFileDelete() {
        this.selectedTemplateMediaUrl = "";
        this.file = null;
      },

      async uploadFile() {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const res = await ApiCalls.uploadMedia(formData);
          return res.data;
        } catch (error) {
          console.log("error :>> ", error);
          return "";
        }
      },

      formatMemory(x) {
        const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        let l = 0;
        let n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
          // eslint-disable-next-line operator-assignment
          n = n / 1024;
        }
        // include a decimal point and a tenths-place digit if presenting
        // less than ten of KB or greater units
        // eslint-disable-next-line prefer-template
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
      },

      _getValidMinuteRanges() {
        let validMinuteRange = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            if (this.time) {
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              const currentHour = parseInt(moment().format("H"));
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              let selectedHour = parseInt(this.time.split(":")[0]);
              const selectedformat = this.time.split(" ")[1];
              // eslint-disable-next-line no-restricted-globals
              if (selectedformat === "pm" && !isNaN(selectedHour)) {
                selectedHour += 12;
              }
              if (selectedHour === currentHour) {
                // eslint-disable-next-line no-undef
                // eslint-disable-next-line radix
                const currentMinute = parseInt(moment().format("m"));
                const allowedMinuteRanges = [15, 30, 45];
                validMinuteRange = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const allowedMinuteRange of allowedMinuteRanges) {
                  if (allowedMinuteRange >= currentMinute) {
                    validMinuteRange.push(allowedMinuteRange);
                  }
                }
              }
            } else {
              validMinuteRange = [];
            }
          }
        }
        return validMinuteRange;
      },
      async _executeFlow(phoneNumbers) {
        const activeClinic = UserHelper.getActiveClinic();
        const messagePayload = {
          FlowID: this.selectedTemplate.flowID,
          ToNumbers: this.patients[0].phone,
          MessageCategoryTypeID: 3,
          FlowPhoneNumber: "+17088872527",
          FlowParameters: [
            {
              Parameter: "firstname",
              ParameterValue: "John",
            },
            {
              Parameter: "lastname",
              ParameterValue: "Doe",
            },
            {
              Parameter: "practicename",
              ParameterValue: activeClinic.name,
            },
            {
              Parameter: "doctor",
              ParameterValue: "Dr. Smith",
            },
            {
              Parameter: "ApptDate",
              ParameterValue: "June 11, 2022",
            },
            {
              Parameter: "message",
              ParameterValue: this.field.content,
            },
          ],
          SendDate: new Date().toLocaleString()
        };
        if (this.selectedTemplate) {
          messagePayload.MessageCategoryTypeID = this.selectedTemplate.templateCategoryID;
        } else {
          messagePayload.MessageCategoryTypeID = 3;
        }
        messagePayload.MessageTypeID = 1; // For SMS, it's 1
        try {
          await Api.ivr.private.initiateBulkCall(messagePayload);
          // this.notification = "Test call successfully initiated";
          this.snackbar = true;
          this.$emit("on-success");
          this.close();
        } catch (error) {
          this.notification = "Unable to send email";
          this.snackbar = true;
          this.$emit("on-error", error);
        }
      },

      _isFlowExecutionRequired() {
        if (
          this.selectedTemplate &&
          this.selectedTemplate.flowID &&
          this.selectedTemplate.flowID.length
        ) {
          return true;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  border: 1px solid rgb(58, 58, 58);
  border-radius: 8px;
  position: relative;
  padding-top: 42px;
  .templateTypeSelectorOuterWrapper {
    position: absolute;
    top: 15px;
    right: 15px;
    .templateTypeSelectorInnerWrapper {
      display: flex;
      border: 1px solid #3dbc83;
      border-radius: 60px;
      padding: 4px 4px;
      background: #3dbc83;
      transition: 0.3s !important;
      &:hover {
        background: #21ad6e;
      }
      .tab {
        padding: 2px 8px;
        border-radius: 60px;
        font-size: 8px;
        color: white;
        font-weight: 600;
        cursor: pointer;
        &.selected {
          color: white;
          // padding: 2px 12px;
          font-size: 10px;
          box-shadow: 6px 6px 8px rgba(0, 0, 0, 0.2);
          background: #020202;
          font-weight: 600;
        }
      }
    }
  }
}
.label {
  color: rgb(17, 17, 17);
  font-weight: 600;
  margin-right: 15px;
  width: 150px;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  z-index: 5555555;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:hover + .dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}
.toggleWrapper {
  display: flex;
  align-items: center;
  span {
    font-size: 1.1rem;
    margin-left: 1rem;
  }
  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }
  input[type="checkbox"]:focus {
    outline: 0;
  }

  .toggle {
    height: 16px;
    width: 42px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: 2px solid grey;
    background: grey;
    transition: all 0.2s ease;
  }
  .toggle:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
  }
  .toggle:checked {
    border-color: rgb(0, 182, 91);
    background: rgb(0, 185, 108);
  }
  .toggle:checked:after {
    transform: translatex(20px);
  }
}
</style>
<style lang="scss">
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .filePart {
    flex: 7;
    display: flex;
    align-items: center;
    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);
      * {
        color: rgb(0, 182, 91);
      }
    }
    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;
      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }
  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;
      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }
      border-radius: 50px;
      font-size: 0.8rem;
    }
    .removeBtn {
      cursor: pointer;
      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}
.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);
    * {
      color: rgb(0, 182, 91);
    }
  }
  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}
.vue__time-picker.time-picker {
  border: none !important;
  border-bottom: 2px solid black !important;
  width: 12.5em !important;
  input {
    height: 1.6em !important;
    border: none !important;
    outline: none !important;
  }
}
.vdatetime-input {
  border-bottom: 2px solid black;
}
.messageCharCounterexcedded {
  color: red;
}
.select-dropdown,
.select-dropdown * {
  margin: 0;
  padding: 0;
  position: relative;
  box-sizing: border-box;
}
.select-dropdown {
  position: relative;
  background-color: #e6e6e6;
  border-radius: 4px;
}
.select-dropdown select {
  font-size: 1rem;
  font-weight: normal;
  width: 100%;
  padding: 8px 24px 8px 10px;
  border: none;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.select-dropdown select:active,
.select-dropdown select:focus {
  outline: none;
  box-shadow: none;
}
.select-dropdown:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 8px;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-top: 5px solid #aaa;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
</style>
